import { render, staticRenderFns } from "./lucking.vue?vue&type=template&id=2111df15&scoped=true"
import script from "./lucking.vue?vue&type=script&lang=js"
export * from "./lucking.vue?vue&type=script&lang=js"
import style0 from "./lucking.vue?vue&type=style&index=0&id=2111df15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111df15",
  null
  
)

export default component.exports